// src/validation/studentValidation.ts
import * as yup from 'yup';
import { AnyYupSchema, buildSchemaFromBase, BuildSchemaOptions } from './validationBuilder';

/* Поля студента (обратите внимание: second_name — как в вашей форме) */
export type StudentFieldKey =
    | 'first_name'
    | 'second_name'
    | 'document_number'
    | 'email'
    | 'password'
    | 'confirm_password';

/* Регексы */
const nameRegex = /^[А-ЯЁ][а-яё\-\s]+$/; // русское имя/фамилия с заглавной первой буквой
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,}$/;
/* Номер: 8 цифр (студ. билет) или 3 русские заглавные + 7 цифр (диплом) */
const documentNumberRegex = /^\d{8}$|^[А-Я]{3}\d{7}$/;

/* Базовый реестр валидаторов для студента */
export const studentBaseValidators: Record<StudentFieldKey, AnyYupSchema> = {
    first_name: yup
        .string()
        .typeError('Должно быть строкой')
        .required('Поле обязательно')
        .max(50, 'Поле не должно содержать более 50 символов')
        .matches(nameRegex, 'Пожалуйста, введите имя на русском языке. Первая буква заглавная'),

    second_name: yup
        .string()
        .typeError('Должно быть строкой')
        .required('Поле обязательно')
        .max(50, 'Поле не должно содержать более 50 символов')
        .matches(nameRegex, 'Пожалуйста, введите фамилию на русском языке. Первая буква заглавная'),

    document_number: yup
        .string()
        .typeError('Должно быть числом или строкой в нужном формате')
        .matches(documentNumberRegex, 'Номер студенческого билета в формате 00000000 или диплома в формате ААА0000000')
        .required('Поле обязательно'),

    email: yup
        .string()
        .typeError('')
        .max(50, 'Поле не должно содержать более 50 символов')
        .required('Поле обязательно')
        .matches(emailRegex, 'Введите валидный email'),

    password: yup
        .string()
        .required('Поле обязательно')
        .matches(
            passwordRegex,
            'Пароль должен состоять минимум из 6 латинских символов, хотя бы одной заглавной буквы и одной цифры',
        )
        .max(35, 'Пароль не может быть больше 35 символов'),

    confirm_password: yup
        .string()
        .required('Поле обязательно')
        .max(35, 'Пароль не может быть больше 35 символов')
        .oneOf([yup.ref('password')], 'Пароли не совпадают'),

};

/**
 * Привязанный buildSchema: использовать так:
 * buildStudentSchema(['first_name','second_name', ...], { overrideRequired: [...] })
 */
export const buildStudentSchema = (fields: StudentFieldKey[], opts?: BuildSchemaOptions<StudentFieldKey>) =>
    buildSchemaFromBase(studentBaseValidators, fields, opts);

// Форма регистрации студента
export const getStudentRegisterSchema = () =>
    buildStudentSchema(['first_name', 'second_name', 'document_number', 'email', 'password', 'confirm_password'], {
        // overrideRequired: [],
    });
